export default "__VITE_ASSET__DG1p3_AI__"